/* istanbul ignore next */
const ACTIONS = {
    GET_MASTER_BRAND_DATA: 'GET_MASTER_BRAND_DATA',
    GET_MASTER_BRAND_DATA_SUCCESS: 'GET_MASTER_BRAND_DATA_SUCCESS',
    GET_MASTER_BRAND_DATA_ERROR: 'GET_MASTER_BRAND_DATA_ERROR',
    GET_REDIRECT_BRAND_DETAILS: 'GET_REDIRECT_BRAND_DETAILS'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    getMasterBrandData() {
        return {
            type: ACTIONS.GET_MASTER_BRAND_DATA
        };
    },

    getMasterBrandSuccess(response) {
        return {
            type: ACTIONS.GET_MASTER_BRAND_DATA_SUCCESS,
            payload: {
                ...response
            }
        };
    },

    alertError(errorKey) {
        return {
            type: ACTIONS.GET_MASTER_BRAND_DATA_ERROR,
            payload: {
                errorKey
            }
        };
    },

    getRedirectBrandDetails(currency, supportedCurrencies, siteName) {
        return {
            type: ACTIONS.GET_REDIRECT_BRAND_DETAILS,
            payload: {
                currency,
                supportedCurrencies,
                siteName
            }
        };
    }
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
